import { Avatar, AvatarGroup, Box, Stack, Typography } from '@mui/material';

import { CoinIcon } from '@/components/wallets';

import type { WalletCoin } from '@/types';
import type { DispenseAssetView } from '@/types/generated/athena';

type Props = {
  coin?: WalletCoin;
  asset?: DispenseAssetView;
  selected?: boolean;
  onClick?: () => any;
};

const AssetBadge = ({ coin, asset, selected = false, onClick }: Props) => {
  const isToken = coin?.is_token;
  const logo = coin?.chain?.logo_url ?? asset?.logo_url;
  const symbol = coin?.ticker ?? asset?.symbol;
  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={0.5}
      border={1}
      borderColor="text.disabled"
      borderRadius={1}
      bgcolor={selected ? 'primary.main' : '#FAFAFB'}
      color={selected ? 'white' : 'primary.main'}
      p={0.5}
      pr={1}
      onClick={onClick}
      sx={{ cursor: 'pointer' }}
    >
      <AvatarGroup
        sx={{
          '.MuiAvatar-root': {
            border: '2px solid #FAFAFB',
            marginLeft: '-12px',
          },
        }}
      >
        <Avatar sx={{ width: 16, height: 16 }}>
          <CoinIcon hideChain coin={coin} asset={asset} height={16} width={16} />
        </Avatar>
        {isToken && (
          <Avatar sx={{ width: 16, height: 16 }}>
            <Box
              width={16}
              height={16}
              sx={{
                background: `url(${logo})`,
                backgroundPosition: 'center',
                backgroundSize: 'cover',
              }}
            />
          </Avatar>
        )}
      </AvatarGroup>
      <Stack>
        <Typography variant="body2" lineHeight={1} fontWeight="bold">
          {symbol}
        </Typography>
        {isToken && (
          <Typography variant="body2" fontSize={8} lineHeight={1}>
            {coin?.chain?.name}
          </Typography>
        )}
      </Stack>
    </Stack>
  );
};

export default AssetBadge;
